//Función para extraer el nombre de un archivo multimedia en función a su URL.
export const getFileNameFromUrl = (url) => {
    
    const extension = url.split('.').pop().toLowerCase(); // Obtener la extensión del archivo desde el enlace

    let nombreArchivo; // Asignar el nombre de archivo según la extensión
    switch (extension) {
        case 'pdf':
            nombreArchivo = "documento.pdf";
            break;
        case 'doc':
        case 'docx':
            nombreArchivo = "documento.docx";
            break;
        case 'xlsx':
            nombreArchivo = "hoja_de_calculo.xlsx";
            break;
        case 'rar':
            nombreArchivo = "archivo.rar";
            break;
        default:
            nombreArchivo = "archivo"; // Nombre genérico si la extensión no es reconocida
    }

    return nombreArchivo;
};
